import { memo } from 'react';

import { BoardIcon } from '@air/design-icons';

import { NonContributableEmptyState } from '~/components/NonContributableNullState/NonContributableNullState';
import { PublicBoardNoSearchResults } from '~/components/PublicBoard/PublicBoardNoSearchResults';
import { useIsSearchActive } from '~/hooks/search/useIsSearchActive';

export const PublicBoardNullState = memo(() => {
  const { isSearchActive } = useIsSearchActive();

  if (isSearchActive) {
    return <PublicBoardNoSearchResults />;
  }

  return <NonContributableEmptyState icon={BoardIcon} description="Content added to this board will appear here." />;
});

PublicBoardNullState.displayName = 'PublicBoardNullState';
